export default __webpack_public_path__ + "static/media/open_filter.40b86764.svg";